<template>
  <div>
    <vx-card class="relative">
      <div>
        <vs-row vs-w="12" class="mb-5">


          <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            <vs-button @click="goBack" color="primary" type="border">Back</vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
            <h3>Contact Build Allocation  {{ campaignDescription.campaign_name }}</h3>
          </vs-col>

          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
            <!-- <h3>{{ campaignDescription.campaign_name }} Contacts</h3> -->
          </vs-col>
        

      

       

          


          <!-- <vs-col vs-lg="1" vs-sm="4" vs-xs="12">
            <vs-button :color="acceptButtonColor" type="filled"
              @click="acceptSelected">{{ accept_text }}</vs-button>


              <input
              type="checkbox"
              v-model="allSelected"
              style="float:right;"
              @click="selectAll"
            />
          </vs-col> -->
        </vs-row>
      </div>
    </vx-card>

    <vx-card class="vxtable">
    

              <div v-if="showSalesDeveloperSubmit">
            <div class="vx-row mb-2">
              <div class="vx-col sm:w-1/6 w-full ml-5">
                <h6>Assign To :</h6>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <SalesDeveloperAutocomplete
                  :key="companySDSearchComponentKey"
                  class="searchbox"
                  :list="searchDataAdministrators"
                  :searchOn="'selected_sales_developer'"
                  @event-name="handleSalesDeveloper"
                ></SalesDeveloperAutocomplete>
                <span class="text-danger text-sm">{{
                  please_choose_sales_developer
                }}</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-button @click.prevent="updateSalesDeveloperIds"
                  >Submit</vs-button
                >
              </div>
            </div>
            
           
          </div>
                    <div v-if="showDatagrid">
                        <ClientDataGrid
              :key="companySDContactComponentKey"
              @sendSelectionToActualPage="sendSelectionToActualPage"
              ref="DataAdministratorClientSide"
              :columnDefs="contactColumnDefs"
              :rowData="contactRecords"
              :rowSelection="'multiple'"
            >
            </ClientDataGrid>
                      </div>



        


    </vx-card>


  </div>
</template>

<script>
import SalesDeveloperAutocomplete from "@/components/autocomplete/SalesDeveloperAutocomplete.vue";
import ClientDataGrid from "@/components/aggrid/AggridClient.vue";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";
import _ from "lodash";
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import Autocomplete from "@/components/autocomplete/Autocomplete.vue";
import vSelect from "vue-select";
import moment from "moment";
import ProgressBar from 'vue-simple-progress'
 import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import "quill/dist/quill.core.css";
    import "quill/dist/quill.snow.css";
    import "quill/dist/quill.bubble.css";
export default {
  components: { Autocomplete, "v-select": vSelect , ProgressBar ,             flatPickr , ClientDataGrid,SalesDeveloperAutocomplete,CampaignAutocomplete
},
  computed: {
    total_pages () {
      console.log("totla" , this.all_total)
      return Math.ceil(this.all_total / this.limit);
    },
    // cloneItems() {
    //     var clone = this.unmatch_contacts;
    //     var startFrom = (this.pagination.page*this.pagination.rowsPerPage)-this.pagination.rowsPerPage;
    //     return clone.splice(startFrom, this.pagination.rowsPerPage);
    // }
  },
  data() {
    return {
            showDatagrid: false,

            showCampaignSelection: true,

      companySearchComponentKey: 0,
      selected_data_administrator_id: null,
            showSalesDeveloperSubmit: false,

            please_choose_sales_developer: null,

            companySDSearchComponentKey: 0,

         contactDataSource: [],
      contactRecords: [],
            contactColumnDefs: [],

            companySDContactComponentKey:0,

                    configDatePicker: {
      enableTime: false,
      dateFormat: 'Y-m-d',
      allowInvalidPreload	: false,
    },
      configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      allowInvalidPreload	: false,
      enableSeconds : true
    },
      PLeasewait: '',
      uploadPercentage: 0,
      all_unmatched_contacts : [],
      selected: [],
      allSelected: false,
      all_currency_codes : [],
      all_verticals : [],
      all_sic_codes : [],
      all_countries : [],
      selected_unmatched_contact : {}, 
      mandatory_fields: [],
      all_phone_codes:[],
      selected_fields: null,
      phoneTypes: [],
      selected_registered_office_country: null,
      correction_fields_array: [],
      vertical: null,
      selected_vertical: null,
      correction_fields: null,
      selected_registration_jurisdiction: null,
      currencyCodes: [],
      selected_sic_code: null,
      add_or_update_title: null,
      user_id: null,
      user_role: null,
      selected_head_office_country: null,
      abilities: null,
      field_array_columns: [],
      actual_contact_name:null,
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      company_category: null,
      sic_code: null,
      revenue: null,
      currency_code: null,
      registration_jurisdiction: null,
      no_of_employees: null,
      // sic_code_description: null,
      phone_type: null,
      phone_no: null,
      phone_code: null,
      website: null,
      linkedin: null,
      status: null,
      switchboard: null,
      switchboard_phone_code: null,
      site_switchboard: null,
      site_switchboard_phone_code: null,
      company_name: null,
      selected_fields: null,
      registered_office_country_validation: null,
      EnhancedHeadOfficeAutocompleteComponentKey: 0,
      EnhancedRegOfficeAutocompleteComponentKey: 0,
      EnhancedSicCodeAutocompleteComponentKey: 0,
      EnhancedVerticalAutocompleteComponentKey: 0,
      EnhancedRegistrationJurisdictionAutocompleteComponentKey: 0,
      company_registration_number: null,
      country: null,
      isNewContact: null,
      update_id: null,
      table: null,
      popupActive: false,
      updateData: [],
      currency_code_validation: null,
      currencyCodes: [],
      abilities: null,
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      contactDescription: {},
      contactExists: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      headOfficeIsRegisteredOffice: false,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_company_registration_number: null,
      contacts: {
        web: null,
        phone: null,
        linkedin: null,
        main_counter: 0,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        sicCodeWithDescription: [],
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null
      },
      contactDescription: {},
      addNewContactsPopUp: false,
      campaignDescription: [],
      export_link: null,
      enrich_contact_to_master_db_link: null,
      abilities: null,
      campaignId: null,
      componentKey: 0,
      limit: 10,
      currentx: 1,
      paginate: { limit: 10, offset: 0 },
      tableData: [],
      header: [],
      sheetName: "",
      list2: [],
      uploaded_columns: [],
      selected_fields: [
        "ml_company",
        "ml_actual_contact_name",
        [
          [
            "Head Office Address",
            "Registered Office",
            "State",
            "Town",
            "Country",
            "Postal Code",
            "Site Office"
          ]
        ]
      ],
      unmatch_contacts: [],
      accept_text: "Accept",
      acceptButtonColor: "primary",
      accepted_matches: [],
      combined_matches: [],
      all_total : 0
    };
  },
  mounted() {
  this.selectCampaign();
  this.getSDContactColumns();
  this.getContactDataSource();
  },
  watch: {
    
  },
  methods: {
    selectCampaign() {
          this.campaignId = this.$route.params.campaignId;

          this.getCampaignDescription();

    },
   
     updateSalesDeveloperIds() {
      let self = this;
      let data = {};
      data.table_ids = self.selected_table_ids;
      data.data_administrator_id = self.selected_data_administrator_id;
      data.campaign_id = self.campaignId;
      data.assigned_by = self.user_id;
      data.level = "contact";

      if (self.selected_data_administrator_id == null) {
        self.please_choose_sales_developer =
          "Please select data manager to update";
      }


      console.log("data.table_ids", data.table_ids);

      self.$vs.loading();





      if (
        self.selected_data_administrator_id != null &&
        self.selected_table_ids.length != 0 &&
        self.campaignId != null
      ) {
        self.$store
          .dispatch("campaignsManagement/updateContactDataAdministratorIds", data)
          .then(res => {
            if (res) {
              if (res.data.status == "success") {
                self.$refs.DataAdministratorClientSide.gridApi.deselectAll();
                 self.$refs.DataAdministratorClientSide.gridApi.refreshCells({force : true});
                self.getContactDataSource();
                self.$vs.loading.close();

              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }

      
    },
   getContactDataSource() {
      var self = this;
      self.$vs.loading();

      let data = {};
      data.campaign_id = self.campaignId;
      self.$store
        .dispatch("contactsManagement/fetchAllDataBuildContactsForClientSide", data)
        .then(function(response) {
          let response_data = JSON.parse(response.data);

       


   response_data.forEach(function(ele){
            if(ele.added_to_campaign == true){
              ele.added_to_campaign = 'Yes' 
            }else{
              ele.added_to_campaign = 'No' 
            }
          })
          

          

          self.contactRecords = response_data;
          self.showDatagrid = true;


          console.log("contact Records" , self.contactRecords)

          self.$vs.loading.close();

        })
        .catch(err => {
          console.error(err);
        });


    },
    getSDContactColumns() {
      var self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getAllContactSelectedCampaignColumnsForDataBuild",
          self.campaignId
        )
        .then(res => {
            let selected_columns = JSON.parse(res.data);

              selected_columns = selected_columns.filter(function(ele) {
                return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'switchboard_phone_code' 
              });


              var index = 1;
            selected_columns.forEach(function(ele) {
          
              ele.headerName = ele.name;

              if (ele.column_id != "contact_status" && ele.column_id != "contact_status_notes") {
                  ele.field = '_' + ele.id.replaceAll("-", "_");

                if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }

              }else{
                ele.field = ele.column_id;
              }



                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.contactColumnDefs = selected_columns
          let actions = {
            headerCheckboxSelectionFilteredOnly: true,
            headerCheckboxSelection: true,
            headerName: "Actions",
            field: "transactions",
            cellRenderer: "CellRendererActions",
            suppressHeaderMenuButton: true,
            checkboxSelection: true,

            pinned: true,
            width: 50
          };

          this.contactColumnDefs.push(actions);



   let data_assigned_by = {
            field: "assigned_by",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Allocated By"
          };

          this.contactColumnDefs.push(data_assigned_by);



           let added_through = {
            field: "added_through",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Added Through"
          };

          this.contactColumnDefs.push(added_through);

            let added_to_campaign_id = {
            field: "added_to_campaign_id",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Added To Campaign By"
          };

          this.contactColumnDefs.push(added_to_campaign_id);


          let data_assigned_on = {
            field: "assigned_on",
            filter: "agDateColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4,
                     comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (cellValue === null) return -1; // Handle null or empty cell values

            // Convert string cellValue to a Date object
            const cellDate = new Date(cellValue); 

            // Compare the dates
            if (cellDate.getTime() === filterLocalDateAtMidnight.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
            return 0; // Fallback
          },
            },
            headerName: "Allocated On"
          };

          this.contactColumnDefs.push(data_assigned_on);


          













             let added_to_campaign = {
            field: "added_to_campaign",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Added to Campaign"
          };

          this.contactColumnDefs.push(added_to_campaign);

              let added_to_campaign_on = {
            field: "added_to_campaign_on",
            filter: "agDateColumnFilter",
        //     valueFormatter: (params) => {
        //   if (params.value) {
        //     return moment(params.value).format('MM/DD/YYYY'); // Or your desired format
        //   }
        //   return '';
        // },
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4,
               comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (cellValue === null) return -1; // Handle null or empty cell values

            // Convert string cellValue to a Date object
            const cellDate = new Date(cellValue); 

            // Compare the dates
            if (cellDate.getTime() === filterLocalDateAtMidnight.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
            return 0; // Fallback
          },
              
            },
            headerName: "Added To Campaign On"
          };

          this.contactColumnDefs.push(added_to_campaign_on);

          let company = {
            field: "company",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Company"
          };

          this.contactColumnDefs.push(company);

          let accepted = {
            field: "accepted",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Matched ID"
          };

          this.contactColumnDefs.push(accepted);

          let matched_contact = {
            field: "matched_contact",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Matched Contact"
          };

          this.contactColumnDefs.push(matched_contact);



          let data_administrator = {
            field: "data_administrator",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Data Administrator"
          };

          this.contactColumnDefs.push(data_administrator);

          let sorted = _.sortBy(this.contactColumnDefs, function(item) {
            return item.field === "data_administrator" ? 0 : 1;
          });

         

          this.contactColumnDefs = sorted;

        

        })
        .catch(err => {
          console.log(err);
        });
    },
     sendSelectionToActualPage(items) {
      let selected_table_ids = [];

      items.forEach(element => {
        selected_table_ids.push(element.table_id);
      });

      this.selected_table_ids = selected_table_ids;
      this.showSalesDeveloperSubmit = true;
    },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    selectAll() {

    


// this.$vs.loading();






// let matches = this.unmatch_contacts;



var matches = [...this.unmatch_contacts, ...this.all_unmatched_contacts];



if (this.allSelected) {
  matches.forEach(match => {
    this.selected.pop({ id: match.id});
  });
} else {

  

  
  // this.allSelected = false;
  matches.forEach(match => {
    this.selected.push({ id: match.id });
  });
  // this.match_ten_context.map(
  //   function(ele) {
  //     if (ele.page == this.currentx) {
  //       return (ele.ten_selected = true);
  //     }
  //   }.bind(this)
  // );
}

this.selected = this.removeDuplicates(this.selected, "id");


// this.$vs.loading.close();

},
select() {
this.allSelected = false;

// this.match_ten_context.map(
//   function(ele) {
//     if (ele.page == this.currentx) {
//       return (ele.ten_selected = false);
//     }
//   }.bind(this)
// );
},
    getSelectedMandatoryFields() {
      let self = this;
      let selected_campaign_id = self.$route.params.campaignId
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedMandatoryFields",
          selected_campaign_id
        )
        .then(response => {
          let result = JSON.parse(response.data);

          if (result.length != 0) {


          self.mandatory_fields = result.filter(ele => ele.level == 'contact' || ele.level == 'opportunity' );





          }

        })
        .catch(err => {
          if (err) {

            console.log(err)
            return;
          }
          console.error(err);
        });
    },
    campaignDataOptions(){




     let self  = this
   

        self.$router
              .push(
                "/contacts/optionsAfterImportContactToCampaign/" +
                self.campaignId
              )
    


      // this.checkDuplicateExists();
    },
    getPhoneTypes() {
      this.$store
        .dispatch("contactsManagement/getPhoneTypes")
        .then(res => {
          this.contacts.phoneTypes = res.data;
          this.contacts.phoneTypes = this.contacts.phoneTypes.filter(
            item => item.name != "Site Switchboard"
          );
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("contactsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleContactsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    editHeadOfficeCountry() {
      this.showHeadOfficeCountryField = false;
      this.showEditAutocomplete = true;
      this.$refs.EditAutoComplete.$refs.suggestComponent.isInFocus = true;
      this.$refs.EditAutoComplete.$refs.suggestComponent.isClicking = true;
      this.$refs.EditAutoComplete.$refs.suggestComponent.input.value = this.contactDescription.head_office_country;
      this.$refs.EditAutoComplete.$refs.suggestComponent.value = this.contactDescription.head_office_country;
    },
        handleSalesDeveloper() {
      this.selected_data_administrator_id =
        moduleElomarkUserManagement.state.elomark_user.id;
      this.please_choose_sales_developer = null;

      console.log("selected_data_administrator_id" , this.selected_data_administrator_id)
    },
       searchDataAdministrators(inputValue) {
      let data = {};
      data.search = inputValue;
      var self = this;
      return this.$store
        .dispatch("elomarkUsersManagement/getDataAdministrators", data)
        .then(res => {
          let result = res.data;

          console.log("REEEE", result);

          if (result) {
            let mappedArray = [];
            for (const property in result) {
              mappedArray.push({
                id: result[property].uuid,
                name:
                  result[property].first_name +
                  "  -   " +
                  result[property].surname
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    showGroupCompanies() {
      const parentId = this.contactDescription.parent;
      this.$store
        .dispatch("contactsManagement/getGroupCompanies", parentId)
        .then(res => {
          this.groupCompanies = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.groupCompanies = true;
            return;
          }
          console.error(err);
        });
    },
    getPhoneTypes() {
      this.$store
        .dispatch("contactsManagement/getPhoneTypes")
        .then(res => {
          this.phoneTypes = res.data;
          this.phoneTypes = this.phoneTypes.filter(
            item => item.name != "Site Switchboard"
          );
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCurrencyCodes(inputValue) {
      return this.$store
        .dispatch("contactsManagement/getCurrencyCodes")
        .then(response => {
          let response_data = response.data
          let mappedArray = [];
          for (const property in response_data) {
            mappedArray.push({
              id: response_data[property].id,
              label: response_data[property].symbol + ' ' + response_data[property].name + ' ' + response_data[property].code
            });
          }
          this.currencyCodes = mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("contactsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleContactsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllSicCodes() {
     this.$store
        .dispatch("contactsManagement/getAllSicCodes")
        .then(response => {
          let data = response.data
          this.all_sic_codes = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllVerticals() {
     this.$store
        .dispatch("contactsManagement/getAllVerticals")
        .then(response => {
          let data = response.data
          this.all_verticals = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllCurrencyCodes() {
     this.$store
        .dispatch("contactsManagement/getAllCurrencyCodes")
        .then(response => {
          let data = response.data
          this.all_currency_codes = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getSicCodes(inputValue) {
      return this.$store
        .dispatch("contactsManagement/getSicCodes", inputValue)
        .then(response => {
          let data = moduleContactsManagement.state.sic_codes;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].code + ' - ' + data[property].description
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getVerticals(inputValue) {
      return this.$store
        .dispatch("contactsManagement/getVerticals", inputValue)
        .then(response => {
          let data = moduleContactsManagement.state.verticals;
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].vertical
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    showParentName(parentId) {
      this.$store
        .dispatch("contactsManagement/getParent", parentId)
        .then(res => {
          this.parent_name = res.data.company_name;
          // console.log(res.data)
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.parent_name = true;
            return;
          }
          console.error(err);
        });
    },
    showRegistrationJurisdiction(countryId) {
      this.$store
        .dispatch("contactsManagement/getCountry", countryId)
        .then(res => {
          this.RegistrationJurisdiction = res.data.name_1;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.contactDescription.parent = true;
            return;
          }
          console.error(err);
        });
    },
    showVertical(verticalId) {
      this.$store
        .dispatch("contactsManagement/getVertical", verticalId)
        .then(res => {
          this.verticalName = res.data.vertical;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    removeSelectedSiteAddress(site) {
      this.contactDescription.satellite_office = this.contactDescription.satellite_office.filter(
        item => {
          return item.counter != site.counter;
        }
      );
    },
    getAllPhoneCodes() {
      let self = this
      this.$store
        .dispatch("contactsManagement/getAllPhoneCodes")
        .then(response => {
          self.all_phone_codes = response.data
          self.all_countries = response.data
          self.all_phone_codes.forEach(function(ele){
            if(ele.phone_code){
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })

          
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    addSiteOffice() {
      this.contactDescription.satellite_office.push({
        counter: ++this.contacts.main_counter,
        address_1: null,
        address_2: null,
        address_3: null,
        city: null,
        county: null,
        postcode: null,
        country: null,
        phone: null
      });
      // console.log(this.contacts.main_counter);
      // console.log(this.contacts.satellite);
    },
    removeSelectedWeb(url) {
      this.contactDescription.web = this.contactDescription.web.filter(item => {
        return item != url;
      });
    },
    removeSelectedLinkedin(url) {
      this.contactDescription.linkedin = this.contactDescription.linkedin.filter(
        item => {
          return item != url;
        }
      );
    },
    removeSelectedPhone(phone) {
      this.contactDescription.phone = this.contactDescription.phone.filter(
        item => {
          return item != phone;
        }
      );
      this.contactDescription.phone = this.contactDescription.phone;
    },
    removeSelectedSicCode(sic_code) {
      this.contactDescription.sic_code = this.contactDescription.sic_code.filter(
        item => {
          return item != sic_code;
        }
      );
      this.contactDescription.phone = this.contactDescription.phone;
    },
    removeNewSelectedSicCode(selected) {
      this.contacts.joinedSicAndDescription = this.contacts.joinedSicAndDescription.filter(
        item => {
          return item != selected;
        }
      );
    },
    removeNewSelectedPhone(selected) {
      console.log(selected);
      this.contacts.joinedPhoneAndTypes = this.contacts.joinedPhoneAndTypes.filter(
        item => {
          return item != selected;
        }
      );
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        if (res == null) {
          return false;
        }
      }
      return true;
    },
    addPhoneNumbers() {
      if (
        this.contacts.phone &&
        this.contacts.phoneType &&
        !this.contacts.joinedPhoneAndTypes.includes(
          this.contacts.phoneType.name + " - " + this.contacts.phone
        )
      )
        this.contacts.joinedPhoneAndTypes.push(
          this.contacts.phoneType.name + " - " + this.contacts.phone
        );
      let mappedPhoneTypes = {};
      mappedPhoneTypes.phone_no = this.contacts.phone;
      mappedPhoneTypes.phone_type = this.contacts.phoneType.slug;
      this.contacts.phoneWithTypes.push(mappedPhoneTypes);
      this.contacts.phone = null;
      this.contacts.phoneType = null;
    },
    addSicCodes() {
      if (
        this.contacts.sic_code &&
        this.contacts.sic_code_description &&
        !this.contacts.joinedSicAndDescription.includes(
          this.contacts.sic_code + " - " + this.contacts.sic_code_description
        )
      )
        this.contacts.joinedSicAndDescription.push(
          this.contacts.sic_code + " - " + this.contacts.sic_code_description
        );

      let mappedSicDescription = {};
      mappedSicDescription.code = this.contacts.sic_code;
      mappedSicDescription.description = this.contacts.sic_code_description;
      this.contacts.sicCodeWithDescription.push(mappedSicDescription);
      this.contacts.sic_code = null;
      this.contacts.sic_code_description = null;
    },
    addWebsite() {
      if (
        this.contacts.web &&
        !this.contactDescription.web.includes(this.contacts.web)
      )
        this.contactDescription.web.push({ url: this.contacts.web });
      this.contacts.web = null;
    },
    addLinkedin() {
      if (
        this.contacts.linkedin &&
        !this.contactDescription.linkedin.includes(this.contacts.linkedin)
      )
        this.contactDescription.linkedin.push({ url: this.contacts.linkedin });
      this.contacts.linkedin = null;
    },
    updateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (moduleContactsManagement.autocomplete_selected) {
            this.contactDescription.parent =
              moduleContactsManagement.autocomplete_selected.id;
          }
          if (moduleContactsManagement.vertical_selected) {
            this.contactDescription.vertical =
              moduleContactsManagement.vertical_selected.id;
          }
          if (moduleContactsManagement.countries_selected) {
            this.contactDescription.registration_jurisdiction =
              moduleContactsManagement.countries_selected.id;
          }
          if (moduleContactsManagement.head_office_country_selected) {
            this.contactDescription.head_office_country =
              moduleContactsManagement.head_office_country_selected.name;
          }
          this.contactDescription.id = this.$route.params.contactId;

          this.contactDescription.phoneWithTypes = [];
          this.contactDescription.phone.map(phone_ele => {
            phone_ele.phone_type.map(phone_type_ele => {
              if (phone_type_ele.phone_id == phone_ele.id) {
                console.log(phone_type_ele);
                let mappedPhoneTypes = {};
                mappedPhoneTypes.phone_no = phone_ele.phone_no;
                mappedPhoneTypes.phone_type = phone_type_ele.type;
                this.contactDescription.phoneWithTypes.push(mappedPhoneTypes);
              }
            });
          });
          this.contactDescription.phoneWithTypes = _.unionBy(
            this.contactDescription.phoneWithTypes,
            this.contacts.phoneWithTypes,
            "phone_no"
          );

          this.contactDescription.sicCodeWithDescription = [];
          this.contactDescription.sic_code.map(sic_ele => {
            let mappedPhoneTypes = {};
            mappedPhoneTypes.code = sic_ele.code;
            mappedPhoneTypes.description = sic_ele.description;
            this.contactDescription.sicCodeWithDescription.push(
              mappedPhoneTypes
            );
          });
          this.contactDescription.sicCodeWithDescription = _.unionBy(
            this.contactDescription.sicCodeWithDescription,
            this.contacts.sicCodeWithDescription,
            "code"
          );

          if (
            this.contactDescription.revenue != null &&
            this.contactDescription.currency_code == null
          ) {
            this.currency_code_validation =
              "The currency code field is required";
            return false;
          }
          this.addContactAndAddToCampaign();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    submitUpdate() {


      this.$validator.validateAll().then(result => {
        if (result) {


          this.selected_unmatched_contact.campaignId = this.$route.params.campaignId;
          this.selected_unmatched_contact.is_new_contact = "Y"

          this.$store
            .dispatch(
              "contactsManagement/addContactAndAddToCampaign",
              this.selected_unmatched_contact
            )
            .then(response => {

              this.addNewContactsPopUp = false;


              if (response.data == "company_registration_number_exists") {

                this.$vs.dialog({
                  color: "primary",
                  title: `Duplicate Company Registration Number`,
                  text:
                    "Company registration number already exists in the database.Please update it and submit again",
                  accept: this.addNewContactsPopUp
                });
               }
               else if (response.data == "registration_number_and_registered_country_required") {

                this.$vs.dialog({
                  color: "primary",
                  title: `Required Fields`,
                  text:
                    "Company registration number and registered country is required",
                  accept: this.addNewContactsPopUp
                });
                }
               else if (response.data == "required_correction") {
                this.$vs.dialog({
                  color: "primary",
                  title: `Required Correction`,
                  text:
                    "The fields with red title should be corrected. Please update it and submit again",
                  accept: this.addNewContactsPopUp
                });
               }
                  else if (response.data == "registration_number_and_registered_country_required") {

                this.$vs.dialog({
                  color: "primary",
                  title: `Required Fields`,
                  text:
                    "Company registration number and registered country is required",
                  accept: this.addNewContactsPopUp
                });
                }
                else if (response.data == "error") {

 this.$vs.notify({
                  color: "danger",
                  title: "Contact Not Added",
                  text: "Something went wrong. Please contact administrator"
                });


}
              
              
              else {

                this.$vs.notify({
                  color: "success",
                  title: "Contact Added",
                  text: "The contact was added successfully"
                });


              }




              this.$router.go(0);



            })
            .catch(error => {
              console.log(error);
            });
        }

      })



    },

    acceptAlert() {
      this.addNewContactsPopUp = true;




    },
    addContactAndAddToCampaign() {
      this.$store
        .dispatch(
          "contactsManagement/addContactAndAddToCampaign",
          this.contactDescription
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.addNewContactsPopUp = false;

            this.$vs.notify({
              color: "success",
              title: "Contact Exists",
              text: res.data.message
            });
            this.addNewContactsPopUp = true;

            // return false
          } else {
            this.$vs.notify({
              color: "success",
              title: "Contact Added",
              text: "The contact was added successfully"
            });
            this.addNewContactsPopUp = false;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
   
    forceRerender() {
      this.componentKey += 1;
    },
    getCampaignDescription() {
      const campaignId = this.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;

          console.log("Campaign Description" , this.campaignDescription)



        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
   
    goBack: function () {
      this.$router.push('/data_build/data_build_contact_allocation_campaigns')
    },
    proceedToNextStep() {

      let self = this
      this.$vs.loading.close();
      
        self.$router
              .push(
                "/contacts/enrichContactDataToMasterDb/" +
                self.$route.params.campaignId
              )
    },
    acceptSelected() {
      
      let self = this

      self.writeSelectedContactToMasterDB()

    


    },
    updateMasterdbFlag(){

      

        let self = this

          self.$vs.notify({
          color: "primary",
          title: "Update Master DB",
          text: "Please wait while the master db is being updated with matched excel contacts.This may take a few minutes",
        });

        self.$vs.loading()



      let data = {}
            data.campaignId = self.$route.params.campaignId;
            axios
              .post(
                self.$base_url + "/api/contacts/update_master_db_flag",
                data
              )
              .then(response => {
                if (response.data.status == "success") {
                  // console.log("Master DB Flag Updated Successfully");
                  self.$vs.loading.close();

                  self.$router
                    .push(
                      "/contacts/enrichContactDataToMasterDb/" +
                      self.$route.params.campaignId
                    )
             


                  


                } else {
                  self.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: "Something went wrong. Please try again"
                  });
                }






                
                
              
              })
              .catch(error => {
                console.log(error);
              });

              self.$vs.loading.close();



    },
    writeSelectedContactToMasterDB() {


      
      let self = this
       this.PLeasewait = "Please wait while the data is being written to the master database.This may take a few minutes"
      this.selected = this.removeDuplicates(this.selected, "id");



      let selected_data = {};
      selected_data.selected_contacts = this.selected;
      selected_data.campaignId =  this.$route.params.campaignId


    



      axios
        .post(
          this.$base_url + "/api/matched_contacts/write_selected_contact_to_masterdb",
          selected_data, 
          {
            onDownloadProgress: function( progressEvent ) {

  
              let progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );
              
  
              if( progress == 100 ) {
                this.uploadPercentage = 100

                              }
                  
                  
                        }.bind(this),
                        onUploadProgress: function( progressEvent ) {

                  
                    
                          let progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );


                if( progress == 100 ) {
                  this.uploadPercentage = 50

                }


                }.bind(this)
          }).then(response => {
            


          
          let no_of_issues = response.data.data.no_of_issues
          let no_of_added_contact = response.data.data.no_of_added_contact
          

          if (response.data.status == "success") {

            self.$vs.loading.close();


            if (no_of_issues == 0) {


            //  self.updateMasterdbFlag()
              
            } else {
              this.$vs.dialog({
              color: "primary",
              title: `Import Contact To Campaign`,
              text: no_of_added_contact + " contacts were successfully added to the campaign.  However, " + no_of_issues + " selected contacts have issues.  Please resolve these before proceeding.",
              accept: this.finished,
            });
            }


            


           
          }
      


          
        })
        .catch(error => {
          console.log(error);
        });
    },
    finished() {
      this.selected = []
      this.allSelected = false
      location.reload()

      

    },
    // checkDuplicateExists() {
    //   let self = this;
    //   self.paginate.campaignId = self.campaignId;
    //   axios
    //     .post(
    //       this.$base_url + "/api/contacts/deduplicate_csv_contacts_data",
    //       self.paginate
    //     )
    //     .then(response => {
    //       let result = JSON.parse(response.data);

    //       if (result.length == 0) {

    //         self.$router
    //           .push(
    //             "/contacts/optionsAfterImportContactToCampaign/" +
    //             self.campaignId
    //           )
    //           .catch(() => { });
    //           this.$vs.loading.close();

           
    //       } else {
    //         this.deduplicateOldNewCSV();
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    updateOtherFieldDataToMasterDb() {
    let self = this

    self.$vs.dialog({
        color: "primary",
        title: `Import None Core Fields`,
        text: "You are about to import non-core fields to the database.  After you click accept this process will start.  You will receive an email once this process has completed. ",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      let self = this
      let data = {};
      data.campaign_id = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/contacts/update_other_field_to_masterdb_from_csv_table",
          data
        )
        .then(response => {
          if (response.data.status == "success") {


         self.sendCompletedEmail()
            

          

            console.log("Updated other field data to master db")
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    sendCompletedEmail(){
       let self = this
        let data = {}
        data.user_id = self.user_id
        data.message = "Import None Core Fields has been completed."
        data.subject = "Import None Core Fields"
        axios
        .post(
          self.$base_url + "/api/contacts/send_completed_email",
          data
        )
        .then(response => {
          if (response.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Import None Core Fields",
              text: "The email has been sent"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
        
    },
    deduplicateOldNewCSV() {
      let data = {};
      data.campaignId = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/contacts/deduplicate_old_new_csv_contact_data",
          data
        )
        .then(response => {
          if (response.data.status == "success") {
            this.$router.replace(
              "/contacts/deduplicateOldAndNewContactCSVData/" + this.campaignId
            );
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    ucFirstAllWords(str) {
      var pieces = str.split(" ");
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase();
        pieces[i] = j + pieces[i].substr(1);
      }
      return pieces.join(" ");
    },
    formatUploadedHeader(s) {
      if (typeof s !== "string") return "";
      if (s.startsWith("ml_")) return "";
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s;
    },
    getParentCompany(inputValue) {
      return this.$store
        .dispatch("contactsManagement/searchAutocomplete", inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)));
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    }
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }

    
        if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }





    this.campaignId = this.$route.params.campaignId;
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.searchbox {
  padding: 10px 21px;
  width: 600px;
}

.relative {
  /* position: fixed !important; */
  z-index: 999;
  /* width: 98.5%; */
}

.vxtable {
  /* position: absolute !important; */
  margin-top: 20px;
}

.correction_field_class {
  color: red;
}

.correction_field_input_class {
  border: 1px solid red;
}

  .vs-input-class{
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.2);
        font-size: 1rem;
        height: 38px;
        padding-left: 10px;
        padding-right: -10px;
        border-radius: 4px;
        background: transparent;
        transition: all .2s ease;
      
      
      }
</style>
